import { create } from "zustand";

export interface IUserData {
  companyId: number;
  email: string;
  failCount: number;
  id: number;
  isActiveYn: string;
  isLockedYn: string;
  modDt: string;
  name: string;
  password: string;
  regDt: string;
  serviceCd: string;
  tel: string;
  companyName: string;
  userRoleCd: string;
}

export type UserDataStore = {
  userData: IUserData | undefined;
  setUserData: (userData: IUserData) => void;
};

export const userDataStore = create<UserDataStore>((set) => ({
  userData: undefined,
  setUserData: (userData) => set({ userData }),
}));
